import React from 'react'
import { FieldArray } from 'formik'
import { OverlayTrigger, Overlay, Tooltip } from 'react-bootstrap'
import { FiAlertTriangle } from 'react-icons/fi'
import ContentLoader from 'react-content-loader'
import { InputCheckboxSm, InputSwitchSemFormik } from '../../../../../components/Inputs'
import { filtragemTelaManutencao, incluirGuiaBdManutencao, incluirGuiaTelaManutencao } from '../../../../../util/FuncoesComuns'
import useOrdenacao from './useOrdenacao'
import './ordenacao.css'

const QTD_LINHAS_LOADING = 6
const COLSPAN = 12

const colunas = [
    { accessor: 'id', label: 'Cód.', tipo: 'numero', width: '2%' },
    { accessor: 'numero_lote', label: 'Lote', tipo: 'texto', width: '4%' },
    { accessor: 'codigo_barras', label: 'Cód. Barras', tipo: 'texto', width: '8%' },
    { accessor: 'nome_beneficiario', label: 'Paciente', tipo: 'texto', width: 50 },
    { accessor: 'data_procedimento_hora', label: 'Data Proced.', tipo: 'data', width: '14%' },
    { accessor: 'operadora_saude', label: 'Op. de Saúde', tipo: 'texto', width: 50 },
    { accessor: 'estabelecimento_saude', label: 'Estab. de Saúde', tipo: 'texto', width: 50 },
    { accessor: 'status', label: 'Status', tipo: 'texto', width: '10%' },
    { accessor: 'data_insercao', label: 'Data Registro', tipo: 'data', width: '12%' },
    { accessor: 'tipo_executante', label: 'Tipo Exec.', tipo: 'texto', width: '7%', alinhamento: 'text-center' },
    { accessor: 'valor_total_formatado', label: 'Valor', tipo: 'moeda', width: '7%', alinhamento: 'text-center' }
]

const LoadingLinhas = () => {
    const linhas = []
    let y = 12
    for (let i = 0; i < QTD_LINHAS_LOADING; i++) {
        linhas.push(<rect key={i} x={0} y={y} rx="3" ry="3" width="100%" height="20" />)
        y += 36
    }
    return (
        <tr>
            <td colSpan={COLSPAN} style={{ padding: 0 }}>
                <ContentLoader
                    speed={2}
                    width="100%"
                    height={QTD_LINHAS_LOADING * 36 + 12}
                    viewBox={`0 0 1000 ${QTD_LINHAS_LOADING * 36 + 12}`}
                    preserveAspectRatio="none"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#e4e4e4">
                    {linhas}
                </ContentLoader>
            </td>
        </tr>
    )
}

const enriquecer = (item) => ({
    ...item,
    data_procedimento_hora: item.data_procedimento ? item.data_procedimento + ' ' + (item.hora_procedimento || '').slice(0, 5) : ''
})

const Linha = ({ item, checked, onToggle, name }) => (
    <tr>
        <td className='text-center'>
            <InputCheckboxSm name={name} checked={checked} onChange={onToggle} />
        </td>
        <td>{item.id}</td>
        <td>{item.numero_lote}</td>
        <td>{item.codigo_barras}</td>
        <td>{item.nome_beneficiario}</td>
        <td>{item.data_procedimento + ' ' + item.hora_procedimento}</td>
        <td>{item.operadora_saude}</td>
        <td>{item.estabelecimento_saude}</td>
        <td>
            <OverlayTrigger
                popperConfig={{ modifiers: { preventOverflow: { enabled: false } } }}
                id={Math.random()}
                placement="bottom"
                delay={{ show: 25, hide: 25 }}
                overlay={(p) => <Tooltip id={'tooltip ' + (p.id || Math.random())} {...p}>{item.status}</Tooltip>}>
                <div className='guia-status-ellipsis' style={{ background: item.cor_status }}>{item.status}</div>
            </OverlayTrigger>
        </td>
        <td>{item.data_insercao}</td>
        <td style={{ textAlign: 'center' }}>{item.tipo_executante}</td>
        <td style={{ textAlign: 'center' }}>{item.valor_total_formatado}</td>
    </tr>
)

const TabelaGuias = ({ propsFormik, guias, setGuias, totalSelecionados, setTotalSelecionados, refGuias, carregando }) => {
    const guiasSelecionadas = propsFormik.values.guias || []
    const temFiltrosData = propsFormik.values?.filtros?.data_inicial_procedimento || propsFormik.values?.filtros?.data_final_procedimento

    const todasOrdenadas = useOrdenacao([...guiasSelecionadas, ...guias].map(enriquecer))
    const selecionadasOrdenadas = todasOrdenadas.itensOrdenados.filter(x => guiasSelecionadas.some(s => s.id === x.id))
    const novasOrdenadas = todasOrdenadas.itensOrdenados.filter(x => guias.some(g => g.id === x.id))
    const { alternar, obterClasseTh } = todasOrdenadas

    const desselecionarGuia = (item) => {
        const novasSelecionadas = (propsFormik.values.guias || []).filter(x => x.id !== item.id)
        propsFormik.setFieldValue('guias', novasSelecionadas)
        setTotalSelecionados(novasSelecionadas.length)
        if (!guias.find(g => g.id === item.id))
            setGuias([item, ...guias].sort((a, b) => b.id - a.id))
    }

    return (
        <div ref={refGuias} style={{ maxHeight: 500, overflowY: 'auto', overflowX: 'auto', position: 'relative' }}>
            <table className='table tabela-porte-acomodacao table-responsive-md table-striped tabela'>
                <thead className='tabela-lote-ordenavel'>
                    <tr>
                        <th className='text-center' style={{ width: '2%' }}>
                            <InputSwitchSemFormik
                                onClick={() => {
                                    if (guias.length) {
                                        const novas = [...guiasSelecionadas].concat([...guias])
                                        propsFormik.setFieldValue('guias', novas)
                                        setTotalSelecionados(novas.length)
                                        setGuias([])
                                    } else {
                                        propsFormik.setFieldValue('guias', [])
                                        setTotalSelecionados(0)
                                        setGuias([...guiasSelecionadas].sort((a, b) => b.id - a.id))
                                    }
                                }}
                                checked={guiasSelecionadas.length && !guias.length}
                                classeDiv='form-group' name='plantao' size="md" tamanho='a'
                                classeTooltip={'tooltip-input-modal'}
                            />
                        </th>
                        {colunas.map(c => (
                            <th key={c.accessor} style={typeof c.width !== 'undefined' ? { width: c.width, textAlign: c.alinhamento === 'text-center' ? 'center' : undefined } : undefined}
                                onClick={() => alternar(c.accessor, c.tipo)}>
                                <div className='group-title-consulta'>
                                    <span className={obterClasseTh(c.accessor)}>{c.label}</span>
                                </div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {carregando ? <LoadingLinhas /> :
                    <FieldArray name="guias">
                        {() => (
                            guias.length || guiasSelecionadas.length ?
                                <>
                                    {selecionadasOrdenadas.map(item =>
                                        <Linha key={`sel-${item.id}`} item={item} checked={true} name=' cked'
                                            onToggle={() => desselecionarGuia(item)} />
                                    )}
                                    {novasOrdenadas.map((item, index) =>
                                        <Linha key={`nova-${item.id}`} item={item} checked={false} name={`guias[${index}].guia_checked`}
                                            onToggle={() => incluirGuiaTelaManutencao(propsFormik, item, guias, setGuias, setTotalSelecionados)} />
                                    )}
                                </>
                                : <tr><td colSpan={12} className="text-center">
                                    <div className='mt-2'>
                                        <span>{temFiltrosData ? 'Sem Registros' : 'Utilize filtros para buscar guias'}</span>
                                    </div>
                                    <div className='mt-1'>
                                        <small><i>Apenas guias com status <b>Conferidas</b> são buscadas.</i></small>
                                    </div>
                                </td></tr>
                        )}
                    </FieldArray>}
                    {!carregando && propsFormik.touched.guias && (!propsFormik.values.guias || propsFormik.values.guias.length === 0) && propsFormik.errors.guias && !Array.isArray(propsFormik.errors.guias) ?
                        <Overlay target={refGuias.current} show={true} placement="bottom">
                            {p2 => (
                                <Tooltip id={Math.random()} className={"error-tooltip tooltip-input-modal"} {...p2}>
                                    <div className="error">
                                        <FiAlertTriangle className="icone" /> <span>{propsFormik.errors.guias}</span>
                                    </div>
                                </Tooltip>
                            )}
                        </Overlay> : null}
                </tbody>
            </table>
        </div>
    )
}

export default TabelaGuias
